import { useEffect, useState } from "react"
import { useGridStore } from "../../-components/DutyScheduling/state"
import { QuickAddShiftSelection } from "../shifts-and-casts/-components/QuickAddShiftPanel"

export function useQuickAddPanelState({
  panelVisibleStorageKey,
  selectedShiftStorageKey,
}: {
  panelVisibleStorageKey: string
  selectedShiftStorageKey: string
}) {
  const [quickAddPanelVisible, setQuickAddPanelVisible] = useState<boolean>(
    () => {
      if (typeof window === "undefined") {
        return false
      }

      const raw = window.localStorage.getItem(panelVisibleStorageKey)
      if (!raw) {
        return false
      }

      try {
        return Boolean(JSON.parse(raw))
      } catch {
        return raw === "true"
      }
    }
  )

  const [selectedQuickAddShift, setSelectedQuickAddShift] =
    useState<QuickAddShiftSelection | null>(() => {
      if (typeof window === "undefined") {
        return null
      }

      const raw = window.localStorage.getItem(selectedShiftStorageKey)
      if (!raw) {
        return null
      }

      try {
        return JSON.parse(raw) as QuickAddShiftSelection
      } catch {
        return null
      }
    })

  const setSelectedQuickAddShiftInGrid = useGridStore(
    (s) => s.setSelectedQuickAddShift
  )

  useEffect(() => {
    if (!quickAddPanelVisible || !selectedQuickAddShift) {
      setSelectedQuickAddShiftInGrid(null)
      return
    }

    setSelectedQuickAddShiftInGrid({
      action: selectedQuickAddShift.action ?? "add",
      kind: selectedQuickAddShift.kind ?? "presence",
      canDirectAdd: selectedQuickAddShift.canDirectAdd,
      addMode: selectedQuickAddShift.addMode,
      startTime: selectedQuickAddShift.startTime ?? null,
      endTime: selectedQuickAddShift.endTime ?? null,
      shiftTypeId: selectedQuickAddShift.shiftTypeId,
      name: selectedQuickAddShift.name,
    })
  }, [
    quickAddPanelVisible,
    selectedQuickAddShift,
    setSelectedQuickAddShiftInGrid,
  ])

  useEffect(() => {
    if (typeof window === "undefined") {
      return
    }

    window.localStorage.setItem(
      panelVisibleStorageKey,
      JSON.stringify(quickAddPanelVisible)
    )
  }, [panelVisibleStorageKey, quickAddPanelVisible])

  useEffect(() => {
    if (typeof window === "undefined") {
      return
    }

    const timeout = window.setTimeout(() => {
      if (!selectedQuickAddShift) {
        window.localStorage.removeItem(selectedShiftStorageKey)
        return
      }

      window.localStorage.setItem(
        selectedShiftStorageKey,
        JSON.stringify(selectedQuickAddShift)
      )
    }, 150)

    return () => {
      window.clearTimeout(timeout)
    }
  }, [selectedQuickAddShift, selectedShiftStorageKey])

  return {
    quickAddPanelVisible,
    setQuickAddPanelVisible,
    selectedQuickAddShift,
    setSelectedQuickAddShift,
  }
}
